/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default angular.module('agrolog.common.silo.drawing', [])
    .directive('agSiloDrawing', SiloDrawing)
    .name;

/*@ngInject*/
function SiloDrawing() {
    return {
        replace: false,
        scope: true,
        bindToController: {
            silo: '='
        },
        controller: SiloDrawingController,
        controllerAs: 'vm'
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiloDrawingController($scope, $element) {

    let vm = this;

    var canvas = $element[0];
    var context = canvas.getContext('2d');

    $scope.$watch('vm.silo', function() {
        if (vm.silo) {
            redraw();
        } else {
            clear();
        }
    },true);

    function clear(){
        context.clearRect(0, 0, canvas.width, canvas.height);
    }

    function redraw(){
        context.clearRect(0, 0, canvas.width, canvas.height);

        function rx(x){ return (x + 0.5) * width; }
        function ry(y){ return (1.0 - y) * height; }

        var width = canvas.width;
        var height = canvas.height;
        var hopper = vm.silo.hopper;

        function deg_to_rad(d){return d*(Math.PI / 180.0)}

        var total_height = vm.silo.totalheight;
        var eave_height = vm.silo.eaveheight;

        if (eave_height > total_height){
            total_height = eave_height;
        }

        var radius = 0.5 * (vm.silo.diameter / total_height);
        eave_height = (vm.silo.eaveheight / total_height);

        var hopper_height = 0.0;
        if(hopper){
            hopper_height = (vm.silo.hopperheight / total_height);
        }

        var zoom = 1.0;
        if (radius > 0.5){
            zoom = 0.5 / radius
            radius *= zoom;
            eave_height *= zoom;
        }

        context.strokeStyle = '#666666';

        context.beginPath();
        context.moveTo(rx(-radius), ry(eave_height));
        context.lineTo(rx(radius), ry(eave_height));
        context.lineWidth = 2;
        context.stroke();

        context.strokeStyle = '#000000';

        if(!hopper){
            context.beginPath();
            context.moveTo(rx(-radius), ry(hopper_height));
            context.lineTo(rx(radius), ry(hopper_height));
            context.lineWidth = 2;
            context.stroke();
        }

        context.beginPath();
        context.moveTo(rx(radius), ry(0.0));
        context.lineTo(rx(radius), ry(eave_height));
        context.lineTo(rx(0), ry(1.0 * zoom));
        context.lineWidth = 2;
        context.stroke();

        context.beginPath();
        context.moveTo(rx(-radius), ry(0.0));
        context.lineTo(rx(-radius), ry(eave_height));
        context.lineTo(rx(0), ry(1.0 * zoom));
        context.lineWidth = 2;
        context.stroke();


        if (hopper){
            var alpha = deg_to_rad(vm.silo.hopperangle);
            var alpha_off_x = Math.sin(alpha) * (hopper_height / Math.cos(alpha));

            context.strokeStyle = '#666666';

            context.beginPath();
            context.moveTo(rx(-radius), ry(hopper_height));
            context.lineTo(rx(-radius + alpha_off_x), ry(0));
            context.lineTo(rx(0), ry(0));
            context.lineWidth = 2;
            context.stroke();

            context.beginPath();
            context.moveTo(rx(radius), ry(hopper_height));
            context.lineTo(rx(radius - alpha_off_x), ry(0));
            context.lineTo(rx(0), ry(0));
            context.lineWidth = 2;
            context.stroke();
       }
    }

}
